export const translations = {
  Home: {
    EN: "Home",
    DE: "Heim",
  },
  aboutMe: {
    EN: "About Me",
    DE: "Über Mich",
  },
  skills: {
    EN: "Skills",
    DE: "Fertigkeiten",
  },
  experiences: {
    EN: "Experiences",
    DE: "Erfahrungen",
  },
  projects: {
    EN: "Projects",
    DE: "Projekte",
  },
};
